import { FC } from 'react'
import { IInvestmentBase } from '../../../types'
import { sanitizeUrl, getUserAvatar } from '../../../utils'
import { Avatar } from '../../atoms/Avatar'
import { VerifiedName } from '../../atoms/VerifiedName'
import { CommentCard } from '../../organisms/CommentCard'

type Props = {
  item: IInvestmentBase
}

export const AngelCommentCard: FC<Props> = ({ item }) => {
  return (
    <CommentCard
      comment={item.investorComment?.comment}
      href={sanitizeUrl(`/users/${item.angel?.username}`)}
      renderLogo={() => <Avatar src={getUserAvatar(item.angel)} alt={item.angel?.name} />}
      renderName={() => (
        <VerifiedName name={item.angel?.name} isVerifiedAccount={item.angel?.profile.isVerifiedAccount} />
      )}
    />
  )
}
